import { Controller } from "@hotwired/stimulus";
import { createFocusTrap, FocusTrap } from "./focus_trap";

export default class ModalController extends Controller {
  protected focusTrap: FocusTrap | null = null;

  protected initializeFocusTrap(
    element: HTMLElement,
    options: {
      initialFocus?: HTMLElement;
      fallbackFocus?: HTMLElement;
    } = {},
  ): void {
    this.focusTrap = createFocusTrap(element, {
      clickOutsideDeactivates: false,
      escapeDeactivates: false,
      fallbackFocus: options.fallbackFocus || element,
      initialFocus: options.initialFocus || element,
    });
    this.focusTrap.activate();
  }

  disconnect(): void {
    if (this.focusTrap) {
      this.focusTrap.deactivate();
      this.focusTrap = null;
    }
  }
}
